import NonstaticSitemap from './NonstaticSitemap';
export default NonstaticSitemap;